/**
 * Automatic domain redirect utility
 * Redirects users from old domain to new domain seamlessly
 */

const OLD_DOMAIN = 'dontfomo.app';
const NEW_DOMAIN = 'fomo.you';

/**
 * Checks if we're on the old domain and redirects to new domain
 * Preserves the full path and query parameters
 */
export function checkAndRedirectDomain(): void {
  // Only run in browser
  if (typeof window === 'undefined') return;

  const currentHostname = window.location.hostname;
  
  // If we're on the old domain, redirect to new domain
  if (currentHostname === OLD_DOMAIN || currentHostname === `www.${OLD_DOMAIN}`) {
    const newUrl = window.location.href.replace(
      window.location.origin,
      `https://${NEW_DOMAIN}`
    );
    
    // Use 301 redirect for SEO
    window.location.replace(newUrl);
  }
}

/**
 * Get the canonical domain for the app
 * Use this for generating absolute URLs
 */
export function getCanonicalDomain(): string {
  return NEW_DOMAIN;
}

/**
 * Get the current origin, but prefer the new domain
 */
export function getAppOrigin(): string {
  if (typeof window === 'undefined') {
    return `https://${NEW_DOMAIN}`;
  }
  
  const currentHostname = window.location.hostname;
  
  // If on old domain, return new domain
  if (currentHostname === OLD_DOMAIN || currentHostname === `www.${OLD_DOMAIN}`) {
    return `https://${NEW_DOMAIN}`;
  }
  
  // Otherwise return current origin (for localhost, staging, etc.)
  return window.location.origin;
}
